import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { categoryShape } from "utils/propTypeShapes"
import { snakeToCapitalCase } from "utils/stringHelpers"

const CategoryUsageType = ({ category, className = "" }) => (
  <div className={clsx(className, "flex flex-col")}>
    <span className="field-name">Type</span>
    <span className="text-sm">{snakeToCapitalCase(category.usage)}</span>
  </div>
)

CategoryUsageType.propTypes = {
  category: categoryShape.isRequired,
  className: types.string,
}

export default CategoryUsageType
